
define(
	'Tavanoteam.ItemPromotions.ItemPromotions'
,   [
		'Tavanoteam.ItemPromotions.ItemPromotions.View'

		,	'Backbone'
		,	'Utils'
		,	'jQuery'
		,	'underscore'
	]
,   function (
		ItemPromotionsView

		,	Backbone
		,	Utils
		,	jQuery
		,	_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var environment = container.getComponent('Environment');
			var pdp = container.getComponent('PDP');

			//Get Link Text
			var getLinkText = environment.getConfig('TTItemPromotions.linkText');

			if (getLinkText) {
			
				if(pdp)
				{
					pdp.addChildView('Item.Promotions', function() { 
						return new ItemPromotionsView({ container: container });
					});
				}

			}

		}
	};
});
